import Vue from 'vue';
import { EventEditClick, EventRemoveClick } from '../..';
import { i18n } from '@/iti-core-vue';

export class ItiButtonsMaestro extends Vue {
  public buttons() {
    return [
      this.buttonEdit,
      this.buttonDelete,
    ];
  }

  public get buttonEdit() {
    return {
      icon: 'edit',
      tooltip: i18n.tc('maestros.editar'),
      eventName: EventEditClick,
    };
  }

  public get buttonDelete() {
    return {
      icon: 'delete',
      tooltip: i18n.tc('maestros.eliminar'),
      eventName: EventRemoveClick,
    };
  }
}
export const itiButtonsMaestro = new ItiButtonsMaestro();
